/**
 * Pass-through. Client-side encryption has been removed (finding L1).
 *
 * The AES key was compiled into this bundle, so anyone could read it and
 * decrypt or forge any value it protected. It never provided confidentiality -
 * only the appearance of it. Passwords are protected in transit by TLS and at
 * rest by bcrypt on the server, which is where that protection belongs.
 *
 * These functions are kept as no-ops rather than deleted so that every call
 * site does not have to change in the same commit. The servers already accept
 * a plain value, so this is safe to ship once they are deployed.
 */
export const encrypt = (message: string): string => message;

export const decrypt = (ciphertext: string): string => ciphertext;
